import { render } from "./OthersForm.vue?vue&type=template&id=0c76060b&scoped=true&ts=true"
import script from "./OthersForm.vue?vue&type=script&lang=ts"
export * from "./OthersForm.vue?vue&type=script&lang=ts"

import "./OthersForm.vue?vue&type=style&index=0&id=0c76060b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c76060b"]])

export default __exports__